import React, { useEffect, useState } from 'react';

import { Spin } from 'antd';
// import { useSelector } from 'react-redux';
import logo from '../../assets/logo.svg';
import {
  // selectIsLoadingGlobal,
  useGetUserUrlLogoQuery,
} from '../../services/uploadLogo';

interface LogoProps {
  type?: 'default';
}

const Logo: React.FC<LogoProps> = ({ type = 'default' }) => {
  const [logoUrl, setLogoUrl] = useState<string | null>(null);

  // const isLoadingGlobal = useSelector(selectIsLoadingGlobal);
  const { data: logoData, isLoading: isLoadinglogoData } =
    useGetUserUrlLogoQuery();

  const logoMap = {
    default: logo,
  };

  useEffect(() => {
    if (logoData && logoData.length > 0) {
      setLogoUrl(logoData[0].url);
    }
  }, [logoData]);

  return (
    <>
      {isLoadinglogoData ? (
        <Spin />
      ) : (
        <img
          alt="Logo SalesBox"
          src={logoUrl == null ? logoMap[type] : logoUrl}
          height="45"
        />
      )}
    </>
  );
};

export default Logo;
